const URGENCY_REWORDING_FF = 'common.urgencyMessages.rewording';

export {URGENCY_REWORDING_FF};
